import { Box, Typography } from '@mui/material';
import React from 'react';
import { theme } from 'shared/theme';

type AddUserTitleProps = {
  type: string;
};

export default function AddUserTitle({ type }: AddUserTitleProps) {
  return (
    <>
      <Box mt={3} />
      <Typography
        variant="h2"
        style={{
          fontSize: theme.font.sizes.large
        }}
      >
        Adicionar Usuário: {type}
      </Typography>
      <Box mt={2} />
      <Typography
        variant="h3"
        style={{
          fontSize: theme.font.sizes.medium,
          color: theme.colors.TextGrey
        }}
      >
        Preencha as informações necessárias para o cadastro de um novo usuário.
      </Typography>
      <Box mt={1} />
    </>
  );
}
